import React from "react";
import styles from './wallpaperBespoke.module.scss';
import {uploadImage, removeImage} from '../../../actions/wizard';
import { connect } from "react-redux";
import defaultImage from '../../../assets/default.png';


class WallpaperBespoke extends React.Component<any, any>{

    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        }
    }
   // handleUploadImage = (event) => {
   //    try {
   //         let target = event.target;
   //         const { pageDetails } = this.props;
   //         let {files} = target;
   //         if(!files || files.length <= 0 ){
   //             showSnackbar("Plese select images to upload!");
   //             return;
   //         }
   //         this.props.uploadImage({images: files, tag: pageDetails?.type.toLowerCase()});
   //     } catch (error) {
   //         console.error("Error while uploading image in component", error);
   //     }
   // }

    handleRemoveImage = (imageId)=>{
        try {
            //let target = event.target;
            const { pageDetails } = this.props;
            this.props.removeImage({imageId: imageId, tag: pageDetails?.type.toLowerCase()});
        } catch (error) {
            console.error("Error while removing image in component", error);
        }
    }
    handleShowHideModal = (flag)=>{
        try {
            if(flag){
                this.setState({
                    showModal: true
                });
                return;
            }
            this.setState({
                showModal: false
            })
            
        } catch (error) {
            console.error("Error in handleShowHideModal", error);
        }
    }
    render() {
      const { pageDetails } = this.props;
      const wallpaperDetails ={"PARTNER NAME":"","CATALOG NAME":"","CODE":"","NO OF ROLLS":""}
      const scope ={"oil_primer":''}
        return (
            <React.Fragment>
            <div className="page-image-container" style={{background:'#fff'}}>
                <div className="page-heading">{pageDetails?.name}</div>
                <div className="image-section-container">
                    <img crossOrigin="anonymous" src={''} alt="" className="image-view" />
                </div>
            </div>
            <div className="details-heading">WALLPAPER SPECIFICATIONS</div>
            <div className={styles["tables-alignment"]} style={{margin: "15px"}}>
                    <div className={styles.Table}>
                        {
                            wallpaperDetails && Object.keys(wallpaperDetails).map(key=>{
                                return(
                                    <div className={styles.Row}>
                                        <div className={styles['Cell']+" "+styles['headings']}>
                                            <p>{key.replace(/_/g, " ").toString().toUpperCase()}</p>
                                        </div>
                                        <div className={styles.Cell}>
                                            <p>{wallpaperDetails[key].toString().toUpperCase()}</p>
                                        </div>
                                    </div>
                                );
                            })
                        }
                        
                    </div>    
                    <div className={styles.Table}>
                            <div className={styles.Row}>
                                <div className={styles['Cell']+" "+styles['headings']} style={{borderRight: "none"}}>
                                    <p><b>SCOPE</b></p>
                                </div>
                                <div className={styles.Cell} style={{borderLeft: "none"}}>
                                    <p></p>
                                </div>
                            </div>
                            <div className={styles.Row}>
                                <div className={styles['Cell']+" "+styles['headings']}>
                                    <p>OIL PRIMER</p>
                                </div>
                                <div className={styles.Cell}>
                                    <p>{scope["oil_primer"].toString().toUpperCase()}</p>
                                </div>
                            </div>
                    </div>
                    <div className={styles.Table}>
                            <div className={styles.Row}>
                                <div className={styles['Cell']+" "+styles['headings']}>
                                    <p>{"Wallpaper Image1"}</p>
                                    {/* {
                                        wallpaperImage[0] ? <img src={wallpaperImage[0]} width="100px" height="80px" />:""
                                    } */}
                                    <img alt="default Img" src={defaultImage} width="100px" height="80px" />
                                </div>
                                <div className={styles['Cell']+" "+styles['headings']}>
                                    <p>{"Wallpaper Image2"}</p>
                                    {/* {
                                        wallpaperImage[1] ? <img src={wallpaperImage[1]} width="100px" height="80px" />:""
                                    } */}
                                    <img alt="default Img" src={defaultImage} width="100px" height="80px" />
                                </div>
                            </div>
                    </div>
                </div>
        </React.Fragment>

        //   <React.Fragment>
        //        {/* <div className={styles['bespoke-page']}> */}
        //        <div className="page-image-container" style={{background:'#ffffff'}}>
        //             <div className="page-heading">{pageDetails?.name}</div>
        //             <div className="image-section-container">
        //                 {/* <img crossOrigin="anonymous" src={defaultImage} alt="" className="image-view" /> */}
        //             </div>
        //         </div>
        //            {
        //                 pageDetails.name.includes('Wallpaper') && <div className="details-tables">
        //                     <div className="table-header">
        //                         <div className="details-heading">WALLPAPER SPECIFICATIONS</div>
        //                     </div>
        //                 </div>
        //             }
        //        {/* </div> */}
        //     {/* <ImageUpdate styles={styles} show={this.state.showModal} images={images} modalAction={this.handleShowHideModal} upload={} remove={this.handleRemoveImage} /> */}
        //     </React.Fragment>

        )
    }
    

}

export default connect(
    (state: any) => ({
        pageDetails: state.wizard.pageDetails
    }),
    {
        uploadImage,
        removeImage
    }
)(WallpaperBespoke);

